import { USER_MODEL } from "@/models/user-model";
import { PUBLISHING_SCHEDULE_MODEL } from "@/models/publishing-schedule-model";
import { EVENT_MODEL } from "@/models/event-model";
import { CALCULATED_COST_MODEL } from "@/models/calculated-cost-model";
import { BOOKING_APPROVER_MODEL } from "@/models/booking-approver-model";

export const BOOKING_MODEL = "booking";

const bookingModel = {
  templateId: "",
  title: "",
  costCode: "",
  status: "",
  internalDescription: "",
  externalDescription: "",
  poNumber: 0,
  postNumber: 0,
  hireReason: "",
  currencyCode: "",
  expensesAllowed: false,
  totalCost: 0,
  assessmentsAllowed: false,
  addressId: "",
  otherRequirements: [],
  yearsReferencesRequired: 0,
  complianceRequirements: [],
  submittedForApprovalDate: "",
  approvedDate: "",
  filled: false,
  filledPercentage: 0,
  startDate: "",
  deadlineDate: "",
  afterDeadlineApplyKey: "",
  contractType: "",
  vacancies: 0,
  salaryBandLower: 0,
  salaryBandUpper: 0,
  salaryCurrencyCode: "GBP",
  workingHours: "",
  grade: "",
  internalOnly: false,
  applyLinkOverride: null,
  anonymiseApplications: 0,
  maximumApplications: null,
  files: [],
  location: {
    jsonApi: "hasOne",
    type: "addresses"
  },
  function: {
    jsonApi: "hasOne",
    type: "experience-function"
  },
  verifier: {
    jsonApi: "hasOne",
    type: "users"
  },
  manager: {
    jsonApi: "hasOne",
    type: "users"
  },
  approver: {
    jsonApi: "hasOne",
    type: "users"
  },
  applications: {
    jsonApi: "hasMany",
    type: "application"
  },
  comments: {
    jsonApi: "hasMany",
    type: "comment"
  },
  costs: {
    jsonApi: "hasMany",
    type: CALCULATED_COST_MODEL
  },
  candidates: {
    jsonApi: "hasMany",
    type: USER_MODEL
  },
  events: {
    jsonApi: "hasMany",
    type: EVENT_MODEL
  },
  bookingApprovers: {
    jsonApi: "hasMany",
    type: BOOKING_APPROVER_MODEL
  },
  publishingSchedules: {
    jsonApi: "hasMany",
    type: PUBLISHING_SCHEDULE_MODEL
  },
  rootClient: {
    jsonApi: "hasOne",
    type: "organisations"
  },
  client: {
    jsonApi: "hasOne",
    type: "organisations"
  }
};

export const bookingModelActions = [
  "accept",
  "cancel",
  "approve",
  "reject",
  "publish",
  "submit-for-approval",
  "restart",
  "stop",
  "pause",
  "cancel",
  "close",
  "reopen"
];

export default bookingModel;
